export default __webpack_public_path__ + "static/media/H4006.1.ddda05f5.mp3";